import React from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';

import { titleColorStyles, titleStyles } from './styles';
import { LessonTitleProps } from './types';

const LessonTitle: React.FC<LessonTitleProps> = (props) => {
  const {
    className,
    title,
    isCurrentLessonOptional,
    titleClassName,
    color = 'text-text-primary',
    variant = 'display-xxl',
  } = props;
  const { t } = useTranslation();

  return (
    <Stack className={cn('w-full', className)} direction="col">
      {isCurrentLessonOptional ? (
        <Typography className="mb-10" color="text-text-placeholder" variant="label-caps">
          {t('Course:Lesson.OptionalLesson')}
        </Typography>
      ) : null}
      <Typography
        className={cn(titleClassName ?? titleStyles, color ? '' : titleColorStyles)}
        color={color}
        data-id="title"
        variant={variant}>
        {title}
      </Typography>
    </Stack>
  );
};

export default LessonTitle;
